import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { UPDATE_NAVBAR } from '@corefront/redux-aba';
import { useIsExternalNavbarEnabled } from './index';
import { useNavbarListeners } from './userNavbarListeners';
import { useNavbarEvents } from './useNavbarEvents';
import { useRouteMatch } from 'react-router-dom';
import { usePrevious } from '../useCompare';

const useSendNavbarUpdate = () => {
  const dispatch = useDispatch();
  return useCallback(
    (payload) => dispatch({ type: UPDATE_NAVBAR, payload }),
    [dispatch]
  );
};

let previousStringifiedUpdateEvents = null;
let stringfiedEvents = null;

const useNavbarCallback = () => {
  const isExternalNavbarEnabled = useIsExternalNavbarEnabled();
  const { path } = useRouteMatch();
  const previousPath = usePrevious(path);

  const navbarUpdate = useSendNavbarUpdate();
  const events = useNavbarEvents();

  useNavbarListeners(isExternalNavbarEnabled);

  useEffect(() => {
    return () => {
      previousStringifiedUpdateEvents = null;
    };
  }, []);

  try {
    stringfiedEvents = JSON.stringify(events);
  } catch (e) {
    console.log(e);
  }

  return useCallback(() => {
    if (!isExternalNavbarEnabled) {
      return;
    }
    if (
      previousStringifiedUpdateEvents !== stringfiedEvents ||
      path !== previousPath
    ) {
      previousStringifiedUpdateEvents = stringfiedEvents;

      for (const event of events) {
        navbarUpdate(event);
      }
    }
  }, [events, isExternalNavbarEnabled, navbarUpdate, path, previousPath]);
};

export default useNavbarCallback;
